import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, InputSignal, ModelSignal, Signal, signal, WritableSignal, } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SucursalDTO, GetSucursalListResponse, GeoDireccion, GetClosestSucursalResponse, GuiaDTO, CalculatePriceResponse, CalculatePriceRequest } from '../../../shared/models/generated';

@Injectable({
  providedIn: 'root'
})
export class SucursalesService {
  delete(id: number | undefined) {
    return this.http.delete(`${environment.apiUrl}/api/sucursales/${id}`);
  }
  constructor(private http: HttpClient) { }
  update(dto: SucursalDTO | undefined) {
    return this.http.put(`${environment.apiUrl}/api/sucursales`, dto);
  }
  insert(dto: SucursalDTO | undefined) {
    return this.http.post(`${environment.apiUrl}/api/sucursales`, dto);
  }
  resources = {
    get: (id: InputSignal<number | undefined>) => httpResource<SucursalDTO>(() => id() ? { url: `${environment.apiUrl}/api/sucursales/${id()}` } : undefined, { defaultValue: {} as any }),
    getList: () => httpResource<GetSucursalListResponse[]>(() => ({ url: `${environment.apiUrl}/api/sucursales` })),
    getClosest: (direccion: Signal<GeoDireccion | undefined>) => httpResource<GetClosestSucursalResponse>(() => direccion() ? { url: `${environment.apiUrl}/api/sucursales/closest?latitude=${direccion()!.latitude}&longitude=${direccion()!.longitude}` } : undefined)
  }
}
